import {
  FileSizeType,
  FileSizeValue,
} from '@shared/models/enums/file-size-type'

export const fileSizeFormatter = (
  bites: number | undefined,
  format: FileSizeType
) => {
  if (!bites) {
    return 0
  }
  return bites / format
}

export const formatFileSize = (bites: number | undefined) => {
  if (
    fileSizeFormatter(bites, FileSizeType.MB) &&
    +fileSizeFormatter(bites, FileSizeType.MB).toFixed() > 0
  ) {
    return `${fileSizeFormatter(bites, FileSizeType.MB).toFixed(2)} ${FileSizeValue.MB}`
  }
  if (fileSizeFormatter(bites, FileSizeType.KB) > 0) {
    return `${fileSizeFormatter(bites, FileSizeType.KB).toFixed(2)} ${FileSizeValue.KB}`
  }
  return null
}
